import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/SC189.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaClock, FaPassport, FaHome, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const ResidentReturnVisa = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "Thanks to Immiget Global, I got my 5-year RRV approved in just 2 weeks after living overseas for 4 years!",
      name: "Daniel",
      location: "Singapore",
      visaType: "Resident Return Visa (Subclass 155)"
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Resident Return Visa (Subclass 155, 157) – Immiget Global Australia</title>
        <meta
          name="description"
          content="Maintain your Australian permanent residency with Resident Return Visa. Expert guidance for Subclass 155 & 157 RRV applications. High success rate with Immiget Global."
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Resident Return (Subclass 155, 157)
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Individual & Families
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Resident Return (Subclass 155, 157)
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            What is a Resident Return Visa (RRV)?
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            Is your Australian permanent residency expiring soon? The Resident Return Visa (RRV) (Subclass 155 & 157) allows you to re-enter Australia and retain your PR status if you've been overseas. At Immiget Global, we help former and current permanent residents secure their RRV with expert guidance and a high success rate.
          </p>
          
          {/* RRV Benefits */}
          <div className="mt-6">
            <h3 className="text-blue text-xl font-semibold hellix-font mb-3 max-xl:text-center">The RRV ensures you can:</h3>
            <div className="space-y-2">
              <div className="flex gap-2 max-xl:justify-center">
                <FaPassport className="text-blue mt-1 min-w-[16px]" />
                <span className="text-blue text-lg hellix-font">Return to Australia as a permanent resident after travel</span>
              </div>
              <div className="flex gap-2 max-xl:justify-center">
                <FaHome className="text-blue mt-1 min-w-[16px]" />
                <span className="text-blue text-lg hellix-font">Retain your PR status even if living abroad</span>
              </div>
              <div className="flex gap-2 max-xl:justify-center">
                <FaCheckCircle className="text-blue mt-1 min-w-[16px]" />
                <span className="text-blue text-lg hellix-font">Avoid losing your residency rights</span>
              </div>
            </div>
          </div>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Resident Return Visa" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Two Types of RRVs */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Two Types of RRVs
          </h1>
        </div>
        
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Subclass 155 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">155</span>
              </div>
              <div>
                <h3 className="text-blue text-xl font-semibold hellix-font">Subclass 155</h3>
                <p className="text-blue text-lg hellix-font">(5-year or 1-year RRV)</p>
              </div>
            </div>
            <p className="text-blue text-lg hellix-font">
              For PRs with strong ties to Australia
            </p>
          </div>

          {/* Subclass 157 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">157</span>
              </div>
              <div>
                <h3 className="text-blue text-xl font-semibold hellix-font">Subclass 157</h3>
                <p className="text-blue text-lg hellix-font">(3-month RRV)</p>
              </div>
            </div>
            <p className="text-blue text-lg hellix-font">
              For PRs who don't meet the 155 requirements
            </p>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligibility Requirements */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Eligibility for Resident Return Visa
          </h1>
        </div>
        
        <div className="mt-6 space-y-8">
          {/* Subclass 155 Eligibility */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-4">
              Subclass 155 (5-Year or 1-Year RRV)
            </h3>
            <p className="text-blue text-lg hellix-font mb-4">You may qualify if you:</p>
            
            <div className="space-y-2">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Lived in Australia for 2 of the last 5 years as a PR OR</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Have substantial ties to Australia (business, family, property) OR</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Are a former Australian citizen</span>
              </div>
            </div>
          </div>

          {/* Subclass 157 Eligibility */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-4">
              Subclass 157 (3-Month RRV)
            </h3>
            <p className="text-blue text-lg hellix-font mb-4">If you don't meet Subclass 155 requirements, you may still qualify if you:</p>
            
            <div className="space-y-2">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Were a PR for at least 1 day in the last 10 years</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Have compelling reasons for leaving Australia (e.g., family illness)</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Benefits Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Key Benefits of an RRV
          </h1>
        </div>
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={permanentIcon} alt="pr-icon" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Keep your PR status active
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaPassport className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Re-enter Australia anytime before visa expires
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={unlimitedIcon} alt="work-icon" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              No restrictions on work or study
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={iconPeople} alt="citizenship-icon" />
            </div>
            <div className="text-blue text-lg font-normal max-md:px-2 text-center hellix-font">
              Pathway to citizenship remains open
            </div>
          </div>
        </div>
      </div>

      {/* Application Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            How to Apply for a Resident Return Visa
          </h1>
        </div>
        <div className="lg:ml-8 hellix-font mt-3">
          <div className="flex gap-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 1:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Check Eligibility</strong> - Determine if you qualify for Subclass 155 or 157
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 2:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Gather Documents</strong> - Proof of time spent in Australia (passport stamps, employment records), Evidence of ties to Australia (property ownership, family, business), Compelling reasons (if applying for Subclass 157)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 3:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Lodge Your Application Online</strong> - Submit via the Department of Home Affairs
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 4:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              <strong>Wait for Approval</strong>
            </div>
          </div>
        </div>
        
        {/* Processing Times */}
        <div className="mt-6 bg-blue/10 p-6 rounded-lg">
          <h3 className="text-blue text-xl font-semibold hellix-font mb-4">Processing Times:</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center gap-3">
              <FaClock className="text-blue text-xl" />
              <div>
                <span className="text-blue font-semibold hellix-font">Subclass 155:</span>
                <span className="text-blue hellix-font"> 1-3 weeks (for applicants meeting residency requirements)</span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <FaClock className="text-blue text-xl" />
              <div>
                <span className="text-blue font-semibold hellix-font">Subclass 157:</span>
                <span className="text-blue hellix-font"> 4-8 weeks</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Don't Lose Your PR Status! Contact us today for expert RRV assistance.
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>RRV Specialists</strong> – We maximize approval chances, even for complex cases
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Fast Processing</strong> – Avoid delays with error-free applications
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>PR Retention Strategies</strong> – Advice on maintaining residency rights
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Citizenship Pathway Guidance</strong> – Next steps after securing your RRV
            </div>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="mt-6 text-center">
          <button 
            onClick={scrollToContact}
            className="bg-blue text-white px-8 py-3 rounded-lg font-semibold hellix-font hover:bg-blue-700 transition-colors text-lg"
          >
            Contact Immiget Global for Free RRV Assessment
          </button>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Immiget Will Help You */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={helpIcon} alt="help" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            How Immiget Will Help You?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Immiget Global is here to assist at every stage of your RRV journey. Our team provides:
        </div>
        <div className="xl:flex gap-6 mt-4">
          <div className="xl:w-[50%]">
            <img src={helpImage} alt="help" className="h-[100%]" />
          </div>
          <div className="xl:w-[50%] max-xl:mt-4 flex flex-col gap-1">
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Eligibility Assessment:
                  <span className="font-normal">
                    We determine the best RRV pathway based on your circumstances and residency history.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Document Preparation:
                  <span className="font-normal">
                    Our experts help gather all required evidence to support your application.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Application Management:
                  <span className="font-normal">
                    We handle the complete application process ensuring error-free submission.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Ongoing Support:
                  <span className="font-normal">
                    We provide guidance on maintaining PR status and future citizenship pathways.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="lg:text-[28px] text-2xl text-center text-blue font-semibold hellix-font">
          Resident Return Visa FAQs
        </h1>
        <p className="text-blue font-normal text-xl lg:text-[20px] text-center hellix-font">
          Get answers to common questions about Resident Return Visas (Subclass 155 & 157).
        </p>

        <div className="accordion-container mt-8">
          {/* FAQ 1 */}
          <div className="accordion">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(1)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                What if my PR visa has already expired?
              </h2>
              {activeIndex === 1 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  You can still apply for an RRV if you meet eligibility criteria.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 2 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(2)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Can I get an RRV if I've been outside Australia for 10+ years?
              </h2>
              {activeIndex === 2 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Only if you prove strong ties (Subclass 155) or compelling reasons (Subclass 157).
                </p>
              </div>
            )}
          </div>

          {/* FAQ 3 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(3)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Does an RRV lead to citizenship?
              </h2>
              {activeIndex === 3 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 3 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  No, but it preserves your PR status, which is required for citizenship.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 4 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(4)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                How long is an RRV valid?
              </h2>
              {activeIndex === 4 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 4 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Subclass 155: 1 or 5 years, Subclass 157: 3 months
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="RRV Success Stories"
      />

      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default ResidentReturnVisa;